module.exports = __webpack_public_path__ + "assets/img/white.d39d4fe9.png";